import {Component, Input, OnInit, OnDestroy} from "@angular/core";
import {Message} from "../../models/types";
import {MessageParserService, FenceBlock} from "../../services/message.parser.service";

@Component({
  selector: "app-chat-message",
  templateUrl: "./chat-message.component.html",
})
export class ChatMessageComponent implements OnInit, OnDestroy {
  @Input() message!: Message;
  @Input() accentColor = "#FF6D03";

  typingDots = ".";
  typingInterval: any;
  parsedContent: (string | FenceBlock)[] = [];

  constructor(private messageParserService: MessageParserService) {
  }

  ngOnInit(): void {
    if (this.message.isTyping) {
      this.typingInterval = setInterval(() => {
        this.typingDots = this.typingDots === "..." ? "." : this.typingDots + ".";
      }, 500);
    } else if (this.message.content) {
      this.parsedContent = this.messageParserService.parseMessage(this.message.content);
    }
  }

  ngOnDestroy(): void {
    if (this.typingInterval) {
      clearInterval(this.typingInterval);
    }
  }

  isString(item: any): boolean {
    return typeof item === 'string';
  }
}
